// extracted by mini-css-extract-plugin
module.exports = {"card":"CardNew_card__BXWV_","h2":"CardNew_h2__9H63E"};